/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class FilePath {
  /**
  * Absolute path to the file or directory to restore.
  */
  'path': string;
  /**
  * Whether `path` is a directory. If `true`, Eon restores all files in all subdirectories under the path. If `false`, Eon restores only the file at the path. 
  */
  'isDirectory': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "path",
      "baseName": "path",
      "type": "string",
      "format": ""
    },
    {
      "name": "isDirectory",
      "baseName": "isDirectory",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FilePath.attributeTypeMap;
  }

  public constructor() {
  }
}

